<div class="acadmics">
    <div class="dropdown">
       <a class="cmn-white-button mt-0 py-0 fw-600 dropdown-toggle"
     type="button"
    id="dropdownMenuButton1"
    data-bs-toggle="dropdown"
    aria-expanded="false">
    Programs
  </a>
        <div class="dropdown-menu menus scroll-sec" aria-labelledby="dropdownMenuButton1">
            <div class="sec-thirdtitle mb-3  ms-3 mt-3">
                <h5 class="fw-bold">Programs Offered</h5>
            </div>
            <ul class="academics-list right-borderd">
                <li>
                    <a class="accordion active" data-bs-toggle="collapse" data-bs-target="#ug" aria-expanded="false"
                        aria-controls="ug">
                        Under Graduate Programs
                    </a>
                    <div id="ug" class="accordion-collapse collapse show ">
                        <div class="accordion-body scroll-box">
                            <div class="row row-cols-lg-2 g-3">
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        BBA(Computer Application)</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a
                                                    routerLink="ug-bachelor-of-business-administration-computer-application"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class="text-dark">
                                                        Bachelor of Business Administration</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a
                                                    routerLink="ug-bachelor-of-business-administration"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark"> B.Sc. Computer Science</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a
                                                    routerLink="ug-bachelor-of-science-computer-sciencen"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        Bachelor of Commerce</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="  Bachelor of Commerce | GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a
                                                    routerLink="ug-bachelor-of-commerce" class="cmn-white-button">Learn
                                                    More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        B.Sc(Information Technology)</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="B.Sc(Information Technology) | GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a
                                                    routerLink="bsc-Information-technology"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        BBA(International Business)</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a routerLink="bsc-it"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        BCA(Science)</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a
                                                    routerLink="bsc-computer-aplication" class="cmn-white-button">Learn
                                                    More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        BSc(AI-ML)</h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>3 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a routerLink="#"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </li>
                <li>
                    <a class="accordion" data-bs-toggle="collapse" data-bs-target="#pg" aria-expanded="false"
                        aria-controls="pg">
                        Post Graduate Programs
                    </a>
                    <div id="pg" class="accordion-collapse collapse ">

                        <div class="accordion-body scroll-box">
                            <div class="row row-cols-lg-2 g-3">
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        Master of Commerce
                                                    </h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>2 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a routerLink="m-com"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col">
                              <div class="program-card">
                                  <div class="program-details">
                                      <div class="d-flex align-items-start justify-content-between">
                                          <div class="sec-thirdtitle w-auto text-start">
                                              <h5 class=" text-dark">
                                                Master of Science
                                              </h5>
                                          </div>
                                          <div class="share-img w-auto text-end">
                                              <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                  alt="GHRCACS, PUNE">
                                          </div>
                                      </div>
                                      <div class="d-flex justify-content-between">
                                          <div class="pro-year">
                                              <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                              <span>2 Years</span>
                                             <i class="fa-regular fa-clock ms-3"></i>
                                              <span>Full Time</span>
                                          </div>
                                      </div>
                                      <div class="d-flex justify-content-between"><a routerLink="pg-msc"
                                              class="cmn-white-button">Learn More</a>
                                          <a href="https://raisoni.nopaperforms.com/rgi" target="_blank" class="cmn-button text-white">Apply Now</a>
                                      </div>
                                  </div>
                              </div>
                          </div> -->
                                <div class="col">
                                    <div class="program-card">
                                        <div class="program-details">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="sec-thirdtitle w-auto text-start">
                                                    <h5 class=" text-dark">
                                                        Master of Computer Science
                                                    </h5>
                                                </div>
                                                <div class="share-img w-auto text-end">
                                                    <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/icons/share.png"
                                                        alt="GHRCACS, PUNE">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <div class="pro-year">
                                                    <i class="fa fa-calendar-o " aria-hidden="true"></i>
                                                    <span>2 Years</span>
                                                    <i class="fa-regular fa-clock ms-3"></i>
                                                    <span>Full Time</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between"><a routerLink="pg-msc"
                                                    class="cmn-white-button">Learn More</a>
                                                <a href="https://raisoni.nopaperforms.com/rgi" target="_blank"
                                                    class="cmn-button text-white">Apply Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </li>
            </ul>
        </div>
    </div>
</div>
